import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-premium-gradient bg-violet-overlay text-white pt-2 pb-6 px-4 md:pt-6 md:pb-12 overflow-hidden relative" data-id="element-171">
      <div className="absolute inset-0 bg-radial-glow opacity-80 pointer-events-none" data-id="element-172" />
      <div className="max-w-xl mx-auto text-center relative z-10" data-id="element-173">
        <div className="animate-fadeInUp" data-id="element-174">
          <div className="inline-block bg-blue-500/10 text-blue-400 px-4 py-1.5 rounded-full text-[10px] font-bold mb-6 border border-blue-500/20 tracking-widest uppercase" data-id="element-175">
            ✨ SISTEMA MODERNO DE PREPARACIÓN Y AUTONOMÍA. PREPARATE ANTES QUE
            SEA TARDE.
          </div>

          <h1 className="md:text-5xl lg:text-6xl font-extrabold mb-6 px-0 text-[28px] leading-tight" data-id="element-176">
            👉 Dejá de improvisar y prepará tu hogar{' '}
            <span className="bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent" data-id="element-177">
              antes de necesitarlo.
            </span>
          </h1>

          <div className="relative mb-10 max-w-lg mx-auto" data-id="element-178">
            <div className="absolute inset-0 bg-blue-500/20 blur-[80px] rounded-full scale-75 pointer-events-none" data-id="element-179" />
            <img src="https://cdn.magicpatterns.com/uploads/fwN4EHFbxi7THPehQ6WRw6/MOCKUP_600x.png" alt="MegaPack Hogar Preparado" fetchPriority="high" loading="eager" width="600" height="450" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.6)] mockup-glow relative z-10" data-id="element-180" />
          </div>

          <p className="text-gray-400 md:text-lg font-medium mb-8 max-w-sm mx-auto text-[14px]" data-id="element-181">
            Preparación moderna para personas comunes.{' '}
            <span className="text-white" data-id="element-182">Sin paranoia.</span> Sin survivalismo
            extremo. Sin depender de que todo funcione siempre…
          </p>

          <CTAButton text="QUIERO EL SISTEMA COMPLETO" className="w-auto mx-auto mb-8" data-id="element-183" />

          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[11px] md:text-xs text-gray-500" data-id="element-184">
            <div className="flex items-center gap-1" data-id="element-185">
              <ShieldCheck size={14} className="text-brand-yellow" data-id="element-186" />
              <span data-id="element-187">Garantía 7 días sin preguntas</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-188">
              <Lock size={14} className="text-brand-yellow" data-id="element-189" />
              <span data-id="element-190">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-191">
              <CreditCard size={14} className="text-brand-yellow" data-id="element-192" />
              <span data-id="element-193">Pagás en pesos argentinos</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}